// extracted by mini-css-extract-plugin
export default {"fileUpload":"FileUpload_fileUpload__3y8rB","fileContainer":"FileUpload_fileContainer__Yi+tN","loadingText":"FileUpload_loadingText__QZSUX"};